import {
	DndContext,
	DragEndEvent,
	DragOverlay,
	PointerSensor,
	TouchSensor,
	closestCenter,
	useSensor,
	useSensors,
} from '@dnd-kit/core';
import { SortableContext, rectSortingStrategy } from '@dnd-kit/sortable';
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	styled,
} from '@mui/material';
import SortableArticlesItem from './SortableArticlesItem';
import { useTranslation } from 'react-i18next';
import { SortAboutUsListDTO } from '@/api/DTO/information/aboutUs.interface';
import { SortMeditationDTO } from '@/api/DTO/exercise/meditation.interface';

interface DndArticleListSectionProps {
	meditationItems: any;
	handleRepositionItem: (activeIndex: number, overIndex: number) => void;
}

export default function DndArticleListSection({
	meditationItems,
	handleRepositionItem,
}: DndArticleListSectionProps) {
	const { t } = useTranslation();

	// for input methods detection
	const sensors = useSensors(useSensor(PointerSensor), useSensor(TouchSensor));

	// triggered when dragging ends
	const handleDragEnd = (event: DragEndEvent) => {
		const { active, over } = event;
		if (!over) return;

		const activeItem = meditationItems.find(
			(item: SortMeditationDTO) => item.id === active.id
		);
		const overItem = meditationItems.find(
			(item: SortMeditationDTO) => item.id === over.id
		);

		if (!activeItem || !overItem) {
			return;
		}

		const activeIndex = meditationItems.findIndex(
			(item: SortMeditationDTO) => item.id === active.id
		);
		const overIndex = meditationItems.findIndex(
			(item: SortMeditationDTO) => item.id === over.id
		);

		if (activeIndex !== overIndex) {
			handleRepositionItem(activeIndex, overIndex);
		}
	};

	return (
		<DndContext
			sensors={sensors}
			collisionDetection={closestCenter}
			onDragEnd={handleDragEnd}
		>
			<SortableContext
				items={meditationItems.map((i: { id: SortMeditationDTO }) => i.id)}
				strategy={rectSortingStrategy}
			>
				<TableContainer>
					<Table>
						<TableHead>
							<TableRow
								sx={{
									backgroundColor: '#EEF1F6',
								}}
							>
								<StyledTableCell>
									{t('exerciseSetting.tagTextZh')}
								</StyledTableCell>
								<StyledTableCell>
									{t('exerciseSetting.tagTextEn')}
								</StyledTableCell>
								<StyledTableCell>
									{t('exerciseSetting.lastUpdateTime')}
								</StyledTableCell>
								<StyledTableCell>
									{t('exerciseSetting.createTime')}
								</StyledTableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{meditationItems?.map((item: SortAboutUsListDTO) => (
								<SortableArticlesItem key={item.id} item={item} />
							))}
						</TableBody>
					</Table>
				</TableContainer>
				<DragOverlay />
			</SortableContext>
		</DndContext>
	);
}

const StyledTableCell = styled(TableCell)({
	fontWeight: 'normal',
	minWidth: '370px',
});
